import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from "lodash";
import { api } from "../../../app/applicationSlice";
import { RootState, RootThunk } from "../../../app/store";
import { LoadingState } from "../../../models/common";
import { emptyOf, Pagination } from "../../../models/pagination";
import { fromJson, changeWater } from "../../../models/changeWater";
import * as service from "../../../services/changewater";
import {changeWaterParams} from '../../../services/changewater'
interface ChangeWaterState {
  ChargeWatertData: [],
  Total: 0,
  Current: 1,
  detail:changeWater[];

}

const initialState: ChangeWaterState = {
  ChargeWatertData: [],
  Total: 0,
  Current: 1,
  detail:[],
};

const changeWaterSlice = createSlice({
  name: "changeWaterSlice",
  initialState,
  reducers: {
    setData(state, action) {
      state.ChargeWatertData = action.payload
    },
    setTotal(state, action) {
      state.Total = action.payload
    },
    setCurrent(state, action) {
      state.Current = action.payload
    },
    setDetail:  (state, action) => {
      state.detail = action.payload;
    },

   

  },
});

export const {  setData, 
  setTotal,
  setCurrent,setDetail, } = changeWaterSlice.actions;



  export const selectChargeWatertData = (state: RootState) => state.changeWater.ChargeWatertData

  export const selectTotal = (state: RootState) => state.changeWater.Total
  
  export const selectCurrent = (state: RootState) => state.changeWater.Current
  
  

  export const selectDetail = (state: RootState) =>
  state.changeWater.detail;

  export function getChangeWaterList(params: changeWaterParams): RootThunk {
  return api(service.getChangeWaterList(params), (data: any, dispatch) => {
    dispatch(setData(data.records))
    dispatch(setTotal(data.total))
  });
}
export function getChangeWaterDetail( id ?: number): RootThunk {
  return api(service.getChangeWaterDetail(id), (data: any, dispatch) => {
    const list = data
    dispatch(setDetail(list))
  });
}

export default changeWaterSlice.reducer;
